let _ = require("ES/lib/lodash");

export default function(event){
	var buyer_names = _.map(event && event.Buyers, function(Buyer){
		return Buyer.firstname;
	});
	if(_.isEmpty(buyer_names)){
		buyer_names = ['The client'];
	}
	return buyer_names.join(', ');
}



// WEBPACK FOOTER //
// ./src/utils/getBuyerFirstName.js